import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Link } from '@hh.ru/magritte-ui-link';
import { Text } from '@hh.ru/magritte-ui-typography';
import { s as styles } from './breadcrumbs-BfOGCQof.js';

const BreadcrumbsItem = ({ Element = 'a', children, ...rest }) => {
    return (jsx(Link, { Element: Element, ...rest, typography: "label-3-regular", inline: true, children: jsx("div", { className: styles.interactiveText, children: jsx(Text, { Element: "span", typography: "label-3-regular", children: children }) }) }));
};

export { BreadcrumbsItem };
//# sourceMappingURL=BreadcrumbsItem.js.map
